import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { UPLOAD_OPTIONS } from "~/pages/Uploads/options";
import {
  getLocalizedSortableApiKeys,
  localizedSortFieldForApi,
} from "~/shared/lib/localizedSortField";
import { getColumnSortOrder } from "~/shared/ui/TableV2/lib/applyColumnSort";

const uploadsSortFieldAllowed = [
  "createdAt",
  "User",
  "description",
  "type",
  "typeEn",
  "status",
  "statusEn",
];

export const getUploadsSortableApiKeys = (lang: string | null | undefined) =>
  getLocalizedSortableApiKeys(
    UPLOAD_OPTIONS.filter((o) => o !== "file"),
    lang,
  );

export const uploadsSortFieldForQuery = (field?: string) => {
  if (!field) return undefined;
  if (!uploadsSortFieldAllowed.includes(field)) return undefined;
  return field;
};

export const getUploadsColumns = (
  t: TFunction,
  sortField?: string,
  sortType?: string,
  lang?: string | null,
): ColumnsType<any> =>
  UPLOAD_OPTIONS.map((option) => {
    const sortKey = localizedSortFieldForApi(option, lang);
    const title = t(`uploads.${option}`);
    const base = {
      title,
      key: sortKey,
      sorter: option !== "file",
      sortOrder:
        option !== "file"
          ? getColumnSortOrder(sortKey, sortField, sortType)
          : undefined,
    };

    if (option === "createdAt") {
      return { ...base, dataIndex: "createdAt" };
    }
    if (option === "User") {
      return { ...base, dataIndex: "User" };
    }
    if (option === "status") {
      return {
        ...base,
        dataIndex: "statusValue",
        render: (_: unknown, record: { status?: unknown }) => record.status,
      };
    }
    if (option === "description") {
      return { ...base, dataIndex: "description" };
    }
    if (option === "type") {
      return { ...base, dataIndex: "type" };
    }
    if (option === "file") {
      return {
        ...base,
        dataIndex: "file",
        render: (_: unknown, record: { file?: unknown }) => record.file,
      };
    }
    return { ...base, dataIndex: option };
  });
